import { differenceInDays } from 'date-fns/fp'

export const isExpired = (endDate: Date): boolean => {
  const currentDate = new Date()
  const daysAway = differenceInDays(currentDate, endDate)

  return daysAway <= -1
}
